const InfoRoundButton = (props) => {    
    return  <button type="button" style={{marginLeft:"05px", marginRight:"03px", height:"14px", marginBottom:"02px", width:"14px", backgroundColor:"#7F7F7F"}} onClick={props.onClick} title={props.message}  className={`btn btn-default btn-circle btn-my`} >
                <p style={{marginTop:"-11px"}}> <i className={`fa fa-${props.icon ?? 'info'} fa-fw img-circle`}style={{color:"white", fontSize:"8px"}} ></i></p>
             </button>
}
export default InfoRoundButton;